<template>
    <div class="main">
        <c-panel>
            <lixeira></lixeira>
        </c-panel>
    </div>
</template>
<script>

import lixeira from "./lixeira"

export default {
    components:{ lixeira }
}
</script>
